import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "loading",
  "use": "loading-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 28 28\" id=\"loading\">\n<path d=\"M14,0.5c7.5,0,13.5,6,13.5,13.5s-6,13.5-13.5,13.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5c5.8,0,10.5-4.7,10.5-10.5\n\tS19.8,3.5,14,3.5S3.5,8.2,3.5,14c0,0.8-0.7,1.5-1.5,1.5S0.5,14.8,0.5,14C0.5,6.5,6.5,0.5,14,0.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol